// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"GraficoSeguradorasFunil_tooltip__2l5eM","legendaPizza":"GraficoSeguradorasFunil_legendaPizza__2lVAF"};